import React, { useState } from 'react';
import { ExternalLink, X } from 'lucide-react';
const projects = [{
  id: 1,
  title: 'The Botanical Gallery',
  category: 'Floristería Boutique',
  image: 'https://cdn.magicpatterns.com/uploads/vCATGD2Y68SsQ9qNLRx9Dn/pagina2.jpg',
  description: 'Diseñamos una landing page elegante y sofisticada para The Botanical Gallery, una floristería boutique especializada en arreglos florales de alta gama. El diseño incorpora una paleta de colores naturales con toques de verde esmeralda y dorado, reflejando la exclusividad de sus productos. Implementamos una galería visual impactante que destaca la belleza de cada arreglo floral, con secciones dedicadas a colecciones estacionales, servicios personalizados y un sistema de reservas integrado.',
  testimonial: '"Krove Latam capturó perfectamente la esencia de mi negocio. La página web refleja la elegancia y calidad que ofrezco a mis clientes. Desde el lanzamiento, he recibido un 40% más de consultas y mis ventas online han crecido significativamente. El proceso fue increíblemente profesional y el resultado superó todas mis expectativas." - María Elena, Propietaria'
}, {
  id: 2,
  title: 'Onyx & Steel',
  category: 'Barbería Premium',
  image: 'https://cdn.magicpatterns.com/uploads/wtUctepBBEMsxxo66bUUtT/pagina1.jpg',
  description: 'Creamos una presencia digital masculina y sofisticada para Onyx & Steel, una barbería premium que combina tradición y lujo. El diseño utiliza una paleta oscura con acentos dorados, evocando exclusividad y profesionalismo. Incluimos un sistema de reservas en línea, galería de estilos de corte, presentación del equipo de barberos expertos, y una sección de productos de cuidado masculino. La página proyecta la experiencia premium que los clientes reciben en el establecimiento.',
  testimonial: '"La landing page que Krove Latam diseñó para mi barbería es simplemente espectacular. Mis clientes constantemente me felicitan por lo profesional que se ve mi negocio online. Las reservas por la web han aumentado un 60% y ahora atraigo clientes de toda la ciudad que nos encuentran en Google. Definitivamente valió cada centavo de la inversión." - Carlos Rodríguez, Fundador'
}, {
  id: 3,
  title: 'Gloss & Chrome Lab',
  category: 'Spa de Uñas',
  image: 'https://cdn.magicpatterns.com/uploads/sMQCgetGbrsj9twj3g5d4z/pagina3.jpg',
  description: 'Desarrollamos una landing page futurista y vanguardista para Gloss & Chrome Lab, un spa de uñas que se especializa en diseños de alta tecnología y tendencias de moda. El diseño incorpora elementos holográficos, gradientes vibrantes y una estética cyber-chic que refleja la innovación del negocio. Incluimos una galería interactiva de diseños, sistema de citas online, catálogo de servicios con precios transparentes, y una sección de tendencias actuales en nail art.',
  testimonial: '"¡Wow! Krove Latam entendió perfectamente mi visión de un spa de uñas moderno y tecnológico. La página web es una obra de arte que refleja exactamente el nivel de creatividad que ofrezco a mis clientas. He notado que las clientas nuevas llegan más informadas sobre mis servicios y el 70% de mis citas ahora se reservan a través de la web. ¡Increíble trabajo!" - Valentina Sánchez, Directora Creativa'
}];
export function WorkGallery() {
  const [selectedProject, setSelectedProject] = useState<(typeof projects)[0] | null>(null);
  return <section id="servicios" className="py-24 px-6 bg-background relative" data-id="element-247">
      <div className="max-w-7xl mx-auto" data-id="element-248">
        <div className="text-center mb-16" data-id="element-249">
          <h2 className="text-sm font-bold tracking-[0.3em] text-primary uppercase mb-4" data-id="element-250">
            Nuestro Trabajo
          </h2>
          <p className="text-3xl md:text-4xl font-serif text-white" data-id="element-251">
            Diseños que proyectan{' '}
            <span className="italic text-text-secondary" data-id="element-252">profesionalismo</span>
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-253">
          {projects.map(project => <div key={project.id} className="group relative rounded-2xl overflow-hidden glass-panel transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(77,111,255,0.2)]" data-id="element-254">
              {/* Mockup Container */}
              <div className="p-4 bg-white/5 border-b border-white/5" data-id="element-255">
                <div className="flex gap-1.5 mb-3" data-id="element-256">
                  <div className="w-2.5 h-2.5 rounded-full bg-red-500/50" data-id="element-257"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-yellow-500/50" data-id="element-258"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-green-500/50" data-id="element-259"></div>
                </div>
                <div className="relative aspect-[16/10] overflow-hidden rounded-lg" data-id="element-260">
                  <img src={project.image} alt={`Proyecto ${project.title}`} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" data-id="element-261" />
                  <div className="absolute inset-0 bg-background/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-262">
                    <button onClick={() => setSelectedProject(project)} className="flex items-center gap-2 text-white font-medium bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20 hover:bg-white/20 transition-colors" data-id="element-263">
                      Ver detalle <ExternalLink className="w-4 h-4" data-id="element-264" />
                    </button>
                  </div>
                </div>
              </div>

              <div className="p-6" data-id="element-265">
                <h3 className="text-xl font-serif font-medium text-white mb-1" data-id="element-266">
                  {project.title}
                </h3>
                <p className="text-text-secondary text-sm" data-id="element-267">
                  {project.category}
                </p>
              </div>
            </div>)}
        </div>
      </div>

      {/* Modal */}
      {selectedProject && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fadeIn" data-id="element-268">
          <div className="relative max-w-4xl w-full max-h-[90vh] overflow-y-auto bg-[#0F111A] rounded-3xl border border-white/10 shadow-2xl" data-id="element-269">
            <button onClick={() => setSelectedProject(null)} className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md flex items-center justify-center transition-colors border border-white/20" data-id="element-270">
              <X className="w-5 h-5 text-white" data-id="element-271" />
            </button>

            <div className="p-8 md:p-12" data-id="element-272">
              <div className="mb-8" data-id="element-273">
                <span className="inline-block px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold tracking-wider uppercase mb-4 border border-primary/20" data-id="element-274">
                  {selectedProject.category}
                </span>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-275">
                  {selectedProject.title}
                </h2>
              </div>

              <div className="mb-8 rounded-2xl overflow-hidden border border-white/10" data-id="element-276">
                <img src={selectedProject.image} alt={selectedProject.title} className="w-full h-auto" data-id="element-277" />
              </div>

              <div className="space-y-6" data-id="element-278">
                <div data-id="element-279">
                  <h3 className="text-xl font-semibold text-white mb-3 flex items-center gap-2" data-id="element-280">
                    <span className="w-1 h-6 bg-primary rounded-full" data-id="element-281"></span>
                    Descripción del Proyecto
                  </h3>
                  <p className="text-text-secondary leading-relaxed" data-id="element-282">
                    {selectedProject.description}
                  </p>
                </div>

                <div className="glass-panel p-6 rounded-2xl border-l-4 border-accent-start" data-id="element-283">
                  <h3 className="text-lg font-semibold text-white mb-3" data-id="element-284">
                    Testimonio del Cliente
                  </h3>
                  <p className="text-text-secondary leading-relaxed italic" data-id="element-285">
                    {selectedProject.testimonial}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}